import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Dashboard from './Dashboard/Dashboard'
import AuthWrapper from './AuthenticatedRoute/AuthWrapper';
import {Layout} from "./Layout/Layout";
import {FaDatabase, FaFolder} from "react-icons/fa";
import {FaChartBar, FaFileExport, FaSuitcase, FaArrowUpRightFromSquare} from "react-icons/fa6";
import {SidebarLink} from "./Layout/components/Sidebar/Sidebar";
import Assumptions from "./Assumptions/Assumptions";
import Login from "./Login/Login";
import NoPermissions from "./NoPermissions/NoPermissions";
import Diagram from "./Diagram/Diagram";
import Callback from "./Callback/Callback";
import Error from "./Error/Error";
import OrganizationPermissions from "./OrganizationPermissions/OrganizationPermissions";
import Costing from "./CostingDB/Costing";
import Templates from './Templates/Templates';
import { Button } from "@chakra-ui/react";
import CustomeAsset from './CustomAssets/CustomAssets';
import Terms from './Terms/Terms';
import { AIChatProvider } from './Simulator/context/AIChatContext';

function RouteTracker() {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);

    return null;
}


export function ExternalSidebarLink({ leftIcon, label, href, ...rest }) {
    return (
      <Button
        as="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        fontSize={16}
        size="lg"
        marginY="3"
        variant="link" 
        fontWeight="400"
        leftIcon={leftIcon}
        color="inherit" // This will inherit the text color from parent
        {...rest}
      >
        {label}
      </Button>
    );
}

function App() {
    return (
        <AIChatProvider>
        <Router>
            <RouteTracker />
            <Layout sideBar={<>
                <SidebarLink leftIcon={<FaFolder size={16}/>} label="Projects"/>
                <SidebarLink leftIcon={<FaChartBar size={16}/>} link="/assumptions" label="Portfolio"/>
                <SidebarLink leftIcon={<FaDatabase size={16}/>} link="/costing" label="Costing Database"/>
                <SidebarLink leftIcon={<FaFileExport size={16}/>} link="/templates" label="Templates"/>
                <SidebarLink leftIcon={<FaSuitcase size={16}/>} link="/customAssets" label="Custom Assets"/>
                <ExternalSidebarLink 
                    leftIcon={<FaArrowUpRightFromSquare size={16}/>}
                    href="https://flowire.gitbook.io/flowire-user-guide/"
                    label="Flowire User Guide"
                />
                
            </>}
                    topBar={<></>}>
                <Routes>
                    <Route index element={<AuthWrapper path="/" element={Dashboard}/>}/>
                    <Route path="/templates" element={<AuthWrapper path="/templates" element={Templates}/>}/>
                    <Route path="/assumptions" element={<AuthWrapper path="/assumptions" element={Assumptions}/>}/>
                    <Route path="/settings" element={<AuthWrapper path="/settings" element={OrganizationPermissions}/>}/>
                    <Route path="/costing" element={<AuthWrapper path="/costing" element={Costing}/>}/>
                    <Route path="/customAssets" element={<AuthWrapper path="/customAssets" element={CustomeAsset}/>}/>
                    
                    <Route path="/terms" element={<AuthWrapper path="/terms" element={Terms}/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/nopermissions" element={<NoPermissions/>}/>
                    <Route
                        path="/d/:dataId/:isSim?"
                        element={<AuthWrapper element={Diagram}/>}
                    />
                    <Route path="/callback" element={<Callback/>}/>
                    <Route path="/error" element={<Error/>}/>
                </Routes>

            </Layout>
        </Router>
        </AIChatProvider>
    );
}


export default App;
